import React from 'react';
import PropTypes from 'prop-types';
import Links from 'components/Link';
import s from './TimelinePoll.scss';

const resultColorCss = [
  s.shadeFirst,
  s.shadeSecond,
  s.shadeThird,
  s.shadeFourth,
];
const stateMapping = {
  '81952197': 'tamil-nadu',
  '81952228': 'puducherry',
  '81952242': 'assam',
  '81952253': 'west-bengal',
  '81952267': 'kerala',
};
const getResultCss = i =>
  resultColorCss[i] || resultColorCss[resultColorCss.length - 1];

const PollResult = props => {
  const { selectedOption, data: { options }, isElectionPoll, dataUrl } = props;

  let resultList = [];
  if (options instanceof Array) {
    // resultList = options.sort((a, b) => b.perc - a.perc);
    resultList = options;
  }

  const redirectElectionPage = () => {
    try {
      if (dataUrl && dataUrl.split('?')[1].length) {
        const stateId = dataUrl.split('?')[1].split('=')[1];
        window.location.href = `https://${
          window.location.host
        }/elections/assembly-elections/${stateMapping[stateId]}`;
      }
    } catch (e) {
      // console.log('e', e);
    }
  };

  return (
    <div className={`${s.pollresult} pollresult`}>
      {resultList.map((item, i) => (
        <div
          className={`${s.answers} ${getResultCss(i)} ${
            selectedOption &&
            selectedOption.value &&
            item.value === selectedOption.value
              ? s.userPolled
              : ''
          }`}
        >
          {/* {i === 0 && <i>Tick</i>} */}
          <span className={`${s.shade}`}>
            <i style={{ width: `${item.perc}%` }} />
          </span>
          <span>{item.value}</span>{' '}
          <span className={s.percentage}>{item.perc}%</span>
        </div>
      ))}
      {isElectionPoll && (
        <div className={s.electionLinks}>
          For more elections coverage{' '}
          <Links
            to="#"
            onClick={redirectElectionPage}
            className={`${s.morenews}`}
          >
            click here
          </Links>
        </div>
      )}
    </div>
  );
};

PollResult.propTypes = {
  data: PropTypes.shape({
    options: PropTypes.shape([]),
  }).isRequired,
  selectedOption: PropTypes.shape({}).isRequired,
  isElectionPoll: PropTypes.bool,
};

PollResult.defaultProps = {
  isElectionPoll: false,
};

export default PollResult;
